import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from '@zurich/common/hooks';
import { getInsuranceSegmentKeyPrefix } from '@zurich/common/utils';
import { useIsDesktop } from '@zurich/ui/hooks';
import { Tag } from '@zurich/ui/legacy/components';
import { styled } from '@zurich/ui/legacy/utils';
import { PolicySegmentClickable } from './PolicySegmentClickable';
export function PolicySegments({ insuranceSegments, simpleView, }) {
    const { t } = useTranslation();
    const isDesktop = useIsDesktop();
    return (_jsx(DivFlexStyled, { children: insuranceSegments?.map((segment) => {
            if (typeof segment === 'string') {
                if (!segment) {
                    return null;
                }
                return (_jsx("div", { children: _jsx(StyledTag, { small: !isDesktop, variant: "grey", children: simpleView
                            ? t(`contract:premium.insuranceSegments.${segment}`)
                            : getInsuranceSegmentKeyPrefix(segment) }, segment) }, segment));
            }
            return (_jsx("div", { children: _jsx(PolicySegmentClickable, { segment: segment }, getInsuranceSegmentKeyPrefix(segment?.segmentKey)) }, getInsuranceSegmentKeyPrefix(segment?.segmentKey)));
        }) }));
}
const StyledTag = styled(Tag)(({ theme }) => ({
    marginRight: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
        wordBreak: 'break-word',
    },
}));
const DivFlexStyled = styled('div')(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
}));
